import { BASE_ICONS8_ILLUSTRATION_URL, BASE_ICONS8_URL, BASE_ICON_V1_URL } from 'constants/icon';
import { getInfographUri } from 'utils/getInfographUri';

export const s3IconFetcher = (iconId: string) => fetch(`${BASE_ICON_V1_URL}${iconId}.json?`).then((res) => res.json());
export const icons8Fetcher = (iconPath: string) =>
  fetch(getInfographUri(`${BASE_ICONS8_URL}${iconPath}`)).then((res) => res.json());
export const icons8IllustrationFetcher = (iconId: string) =>
  fetch(getInfographUri(`${BASE_ICONS8_ILLUSTRATION_URL}${iconId}`)).then((res) => res.text());
